import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import TimeAgo from './common/TimeAgo'

import Avatar from './common/Avatar'

const Comments = ({ edges, pageInfo, onLoadMore }) => {
  if (edges.length === 0) return <div>No comments added to this question yet.</div>
  return (
    <div>
      {/*{edges.map(({ node: comment }, index) => {*/}
      {edges.slice(0).reverse().map(({ node: comment }, index) => {
        const { content, creator, image, isAnonymous, nickname, created } = comment
        const isLast = edges.length === index + 1
        const displayName = isAnonymous ? nickname : creator.slackRealName

        return (
            <div key={index} className={cn('d-flex flex-row align-items-center py-2', { '': !isLast })}>
          {/*<div key={index} className={cn('d-flex flex-row align-items-center py-3', { 'border-bottom border-medium': !isLast })}>*/}
            <div className="px-2">
              <Avatar src={image} />
                {/*<Avatar src={image} width={36} />*/}
            </div>
              <div className="px-2">
                  <div>{content}</div>
                  <div className="text-secondary">{displayName} <span className="text-secondary"> - <TimeAgo date={created} /> </span></div>
              </div>
          </div>
        )
      })}

      {pageInfo.hasNextPage ? (
        <div className="col-lg-4 offset-lg-4 text-center">
          <button className="btn btn-primary" onClick={onLoadMore}>
            Show more
          </button>
        </div>
      ) : null}
    </div>
  )
}

Comments.propTypes = {
  edges: PropTypes.array.isRequired,
  pageInfo: PropTypes.object.isRequired,
  onLoadMore: PropTypes.func.isRequired,
}

export default Comments



// WEBPACK FOOTER //
// ./src/components/Comments.jsx